function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
// eslint-disable-next-line no-restricted-imports
import { jsx } from 'panel';
import { selx } from 'clsx';
import { VNode } from 'snabbdom';
import { TooltipEl } from 'common/components/tooltip';
import { IconSizeType } from 'common/constants';
import { UserListEl } from 'common/widgets/user-list';
import { isEmailDigest } from 'common/query-builder/query-report-header/subscribe-to-boards-menu/util';
import { UserIconEl } from 'common/widgets/user-icon';
import styles from 'apps/boards/src/dashboards-app/manage-digests-mode/subscriptions-page/index.module.styl';
import { CellRenderContext } from 'common/components/table/types';
import { SvgIconEl } from 'common/components/svg-icon';
import tableStyles from 'apps/boards/src/dashboards-app/manage-digests-mode/table.module.styl';
import { ButtonEl } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { CurrentUser } from 'common/report/queries/app-api/user-metadata-client';
import { DashboardDigest } from 'common/query-builder/query-report-header/subscribe-to-boards-menu/types';
import { DIGEST_COPY } from 'common/query-builder/query-report-header/subscribe-to-boards-menu/constants';

/**
 * Below are the panel version of the components used in index.tsx for table cellRenderer. Remove this code
 * when <TableEl> is fully converted to React.
 */

export const CellDigestDashboardPanel = (row, context: CellRenderContext) => <div class={{
  [tableStyles.unknown]: row.model.dashboard_foreign_private
}} style={{
  display: "flex",
  alignItems: "center",
  fontWeight: "500"
}} data-sentry-component="CellDigestDashboardPanel" data-sentry-source-file="util.tsx">
    <SvgIconEl attrs={{
    icon: "brand-dashboard",
    height: "24px"
  }} style={{
    height: "24px"
  }} data-sentry-element="SvgIconEl" data-sentry-source-file="util.tsx" />
    <div>
      {context.matchParts ? context.matchParts.map(part => <span sel='mp-table-cell-match-part'>{part}</span>) : <div sel='.mp-table-cell-label'>{context.label}</div>}
    </div>
  </div>;
export const SubscribeToExistingDigestButtonPanel = (digest: DashboardDigest, isSubscribed: boolean, digestIsBeingUpdatedMap: Map<number, boolean>, currentUser: CurrentUser, onSubscribeToExistingDigest: (digest: DashboardDigest, isSubscribed: boolean) => void, canAccessDigests: boolean): VNode => {
  const currentUserSubbed = isSubscribed;
  const updatingCurrentDigest = digestIsBeingUpdatedMap.get(digest.id);
  let icon = "feed";
  if (updatingCurrentDigest) {
    icon = "spinner";
  } else if (currentUserSubbed) {
    icon = "checkmark";
  }
  return <ButtonEl attrs={{
    icon,
    size: ButtonSize.Small,
    theme: ButtonTheme.Secondary,
    disabled: !canAccessDigests || currentUser === undefined
  }} params={_objectSpread({}, canAccessDigests ? {} : {
    tooltip: {
      text: DIGEST_COPY.missingPermissions
    }
  })} on={{
    click: event => {
      event.stopPropagation();
      onSubscribeToExistingDigest(digest, currentUserSubbed);
    }
  }} data-sentry-element="ButtonEl" data-sentry-component="SubscribeToExistingDigestButtonPanel" data-sentry-source-file="util.tsx">
      {currentUserSubbed ? "Subscribed" : "Subscribe"}
    </ButtonEl>;
};
export const CellDigestCreatorPanel = (row, membersMap): VNode => {
  const member = membersMap.get(row.creator);
  return <UserIconEl attrs={{
    id: member === null || member === void 0 ? void 0 : member.id,
    // Fallback to email for name for external users that have no matching member
    name: (member === null || member === void 0 ? void 0 : member.name) || row.creator,
    email: (member === null || member === void 0 ? void 0 : member.email) || row.creator,
    size: IconSizeType.Small
  }} data-sentry-element="UserIconEl" data-sentry-component="CellDigestCreatorPanel" data-sentry-source-file="util.tsx" />;
};
export const CellDigestRecipientsPanel = (row, membersMap): VNode => {
  if (isEmailDigest(row.model)) {
    return <UserListEl attrs={{
      size: IconSizeType.Small,
      users: row.recipients.map(email => {
        const member = membersMap.get(email);
        return member ? member : {
          email,
          name: email
        };
      })
    }} />;
  }
  const recipients = row.recipients;
  return <div sel={selx(styles.slackRecipientsContainer)} data-sentry-component="CellDigestRecipientsPanel" data-sentry-source-file="util.tsx">
      <TooltipEl data-sentry-element="TooltipEl" data-sentry-source-file="util.tsx">{recipients.join(" ")}</TooltipEl>
      {recipients.map(slackChannelName => {
      return <span sel={selx(styles.slackRecipient)}>{slackChannelName}</span>;
    })}
    </div>;
};